const KEY_AUTH_TOKEN = "AUTH_TOKEN";
const FIRST_NAME = "FIRST_NAME";
const LAST_NAME = "LAST_NAME";
const USER_ID = "USER_ID";
const KEY_TALENT_ID = "TALENT_ID";
const KEY_REFRESH_TOKEN = 'REFRESH_TOKEN';
const USER_ROLES ='USER ROLES'
const USER_EMAIL = 'USER EMAIL'


export const localStorage = {
  setAuthToken: (token: string) => {
    window.localStorage.setItem(KEY_AUTH_TOKEN, token);
  },
  removeAuthToken: async () => await window.localStorage.removeItem(KEY_AUTH_TOKEN),

  setRefreshToken: (token: string) => {
    window.localStorage.setItem(KEY_REFRESH_TOKEN, token);
  },

  removeRefreshToken: async () => await window.localStorage.removeItem(KEY_REFRESH_TOKEN),

  

  getAuthToken: async () =>
    (await window.localStorage.getItem(KEY_AUTH_TOKEN)) as string, 

    setTalentId: async (id: string) => {
      await window.localStorage.setItem(KEY_TALENT_ID, id);
    },
  
    getTalentId: async () =>
      (await window.localStorage.getItem(KEY_TALENT_ID)) as string,
  
    removeTalentId: async () => await window.localStorage.removeItem(KEY_TALENT_ID),
  

  setUserFirstName: async (data: string) => {
    window.localStorage.setItem(FIRST_NAME, data);
  },

  getUserFirstName: async () =>
    (await window.localStorage.getItem(FIRST_NAME)) as string,

  removeUserFirstName: async () => await window.localStorage.removeItem(FIRST_NAME),

  setUserLastName: async (data: string) => {
    window.localStorage.setItem(LAST_NAME, data);
  },

  getUserLastName: async () =>
    (await window.localStorage.getItem(LAST_NAME)) as string,

  removeUserLastName: async () => await window.localStorage.removeItem(LAST_NAME),

  removeClientsTable: async () => await window.localStorage.removeItem("Clients-Table"),
  removeClientsConfigTable: async () => await window.localStorage.removeItem("Clients-Config-Table"),
  removeFileListTable: async () => await window.localStorage.removeItem("FileList-Table"),

  setUserRoles: async (data: any) => {
    window.localStorage.setItem(USER_ROLES, JSON.stringify(data));
  },

  setUserEmail: async (data: any) => {
    window.localStorage.setItem(USER_EMAIL, JSON.stringify(data));
  },

  removeUserEmail: async () => await window.localStorage.removeItem(USER_EMAIL),

  removeUserRoles: async () => await window.localStorage.removeItem(USER_ROLES),


  setUserId: (id: string) => {
    window.localStorage.setItem(USER_ID, id);
  },

  setTalentEmail: (emailAddress: string) => {
    window.localStorage.setItem('TALENT_EMAIL_ADDRESS', emailAddress);
  },

  removeTalentEmail: async () => await window.localStorage.removeItem('TALENT_EMAIL_ADDRESS'),
  

  getUserId: async () =>
    (await window.localStorage.getItem(USER_ID)) as string, 

  removeUserId: async () => await window.localStorage.removeItem('USER_ID'),

  getCongratsMessageSeen : async () =>
    (await window.localStorage.getItem('KEY_CONGRATS_MESSAGE_FLAG')) as string, 

  getAllItemsCompletedAndVerifiedFlag : async () =>
    (await window.localStorage.getItem('KEY_ALL_ITEMS_VERIFIED_FLAG')) as string, 
};
